import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'
import { parseCardsForFeature } from '@/assets/scripts/parsers/cards'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Cards list
@return { Array }
*/
export const getCardsList = state => {
	return parseCardsForFeature(state.cardsList).map(card => {
		return {
			...card,
			productName: card.product,
			cardDescription: card.friendlyName.length ? card.friendlyName : null,
			availableBalance: card.accountingBalance,
			cardBalance: card.balance,
			cardCurrency: card.currency
		}
	})
}
